import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback, errorCallback = null) => {
    return AppModel.post('start', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['meetingInfo'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, errorCallback, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('meetingInfo', null, key)
  },
  removeStore: () => {
    delete store.getters.model.meetingStart
  }
}
